import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=21398630&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=21398630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21398630",
  null
  
)

export default component.exports